import { UseMutationOptions } from '@tanstack/react-query';

import { GenericFailure } from '@playq/services-shared';
import { TeamMessagesSnapshot } from '@playq/octopus2-tgservices';

import { services2 } from '/api/services2';
import { useEitherMutation } from '/api/service-hooks';

import { IMutateMessagePayload } from './types';

export const useCreateMessagesSnapshot = (
  options?: UseMutationOptions<TeamMessagesSnapshot, GenericFailure | Error, IMutateMessagePayload>
) =>
  useEitherMutation(
    ({ appID, teamId, channels, env }) =>
      services2.teamsChatLookupService.messagesSnapshotCreate(appID, teamId, channels, env),
    {
      ...options,
    }
  );
